/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { closeNotificationBanner, closeChangeLogNotification } from '@/redux/actions/notificationActions';
import { ModalBody } from '@/shared/components/NotificationModal';
import { Button } from '@/shared/components/Button';
import { StyledModal, ModalHeader, ModalTitle, ModalCloseButton } from '@/shared/components/Modal';
import Carousel from '@/shared/components/carousel/CarouselSingle';
import { Card, CardBody, CardSubhead } from '@/shared/components/Card';
import { colorYellow } from '@/utils/palette';

const AlertNotifications = () => {
  const dispatch = useDispatch();
  const banners = useSelector((state) => state?.notification?.allNotifications);
  const changeLog = useSelector((state) => state?.notification?.changeLogNotification);

  const carouselItems = Array.isArray(banners)
    ? banners?.map((banner, index) => ({
        id: banner.bannerID,
        name: banner.name,
        message: banner.message,
        isLast: index === banners.length - 1,
      }))
    : [];

  const [modal, setModal] = useState(true);
  const [changeLogmodal, setChangeLogModal] = useState(false);
  const [displayCloseButton, setDisplayCloseButton] = useState(false);
  const [liveBannersLength, setLiveBannersLength] = useState(0);
  const [liveBannersData, setLiveBannersData] = useState([]);
  const [formatedDate, setFormatDate] = useState('');

  useEffect(() => {
    if (banners.length > 0) {
      banners?.map((banner) => banner.status === 'Live');
      const liveBannersL = banners.filter((item) => item.status === 'Live');
      setLiveBannersData(liveBannersL);
      const liveBanners = liveBannersL.length;
      setLiveBannersLength(liveBanners);
      setModal(true);

      // Set formatted date
      if (changeLog?.date) {
        const dateObject = new Date(changeLog.date);
        const year = dateObject.getFullYear();
        const month = dateObject.getMonth() + 1;
        const day = dateObject.getDate();
        const formattedDateData = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
        setFormatDate(formattedDateData);
      }
    } else {
      setModal(false);
    }
  }, [banners]);

  const toggle = () => {
    setModal((prevState) => !prevState);
    const bannerIDs = liveBannersData?.map((item) => item.bannerID);
    dispatch(closeNotificationBanner(bannerIDs, setModal));
    if (changeLog.status === 'Live') {
      setChangeLogModal(true);
    }
  };
  const toggleChangeLog = () => {
    setChangeLogModal((prevState) => !prevState);
    dispatch(closeChangeLogNotification(changeLog?.updateID));
  };

  const handleCarouselChange = (index) => {
    setDisplayCloseButton(index === carouselItems.length - 1);
  };

  return (
    <div>
      {liveBannersData.length > 0 ? (
        <NotificationModal
          show={modal}
          onHide={toggle}
          color='primary'
          backdrop='static'
          keyboard={false}
        >
          <ModalHeader className='mb-1'>
            <ModalTitleIcon className='lnr lnr-flag' />
            <ModalBody>
              <Carousel onSlideChange={handleCarouselChange}>
                {liveBannersData?.map((item, index) =>
                  item.status === 'Live' ? (
                    <div
                      key={item.bannerID}
                      className={index === 0 ? 'first-slide' : ''}
                    >
                      <Card>
                        <ModalTitle
                          centered
                          style={{ marginTop: '20px' }}
                        >
                          {item.name}
                        </ModalTitle>
                        <CardBody>
                          <CardSubhead>{item.message}</CardSubhead>
                        </CardBody>
                        {liveBannersLength - 1 === index ? (
                          <div>
                            <Button
                              variant='primary'
                              onClick={toggle}
                            >
                              Acknowledge
                            </Button>
                          </div>
                        ) : null}
                      </Card>
                    </div>
                  ) : null,
                )}
              </Carousel>
            </ModalBody>
          </ModalHeader>
        </NotificationModal>
      ) : null}

      {changeLogmodal && (
        <NotificationModal
          show={changeLogmodal}
          onHide={toggleChangeLog}
          color='primary'
          backdrop='static'
          keyboard={false}
        >
          <ModalHeader className='mb-1'>
            <ModalCloseButton
              className='lnr lnr-cross'
              aria-label='close-btn'
              type='button'
              onClick={toggleChangeLog}
            />
            <h2>Change Log</h2>
            <h4 style={{ textAlign: 'left', fontWeight: 800 }}>{formatedDate}</h4>
            <p style={{ textAlign: 'left' }}>{changeLog?.summary}</p>
            <ModalBody>
              <div style={{ height: '150px', overflowY: 'auto' }}>
                {changeLog?.changeLog?.map((item, index) => (
                  <div
                    key={item.id}
                    style={{
                      marginTop: '8px',
                      display: 'flex',
                    }}
                  >
                    {item.type === 'New' && <NewStatus>{item.type}</NewStatus>}
                    {item.type === 'Feature' && <ImprovedStatus>{item.type}</ImprovedStatus>}
                    {item.type === 'Bug Fix' && <BugFixStatus>{item.type}</BugFixStatus>}
                    {item.type === 'Bug' && <BugStatus>{item.type}</BugStatus>}
                    {item.type === 'bug' && <BugStatus>{item.type}</BugStatus>}
                    {item.type === 'enhancement' && <EnhancementStatus>{item.type}</EnhancementStatus>}
                    <p>{item?.description}</p>
                  </div>
                ))}
              </div>
            </ModalBody>
          </ModalHeader>
        </NotificationModal>
      )}
    </div>
  );
};

export default AlertNotifications;

const NotificationModal = styled(StyledModal)`
  .modal-content {
    width: 500px;
  }
}
`;

const ModalTitleIcon = styled.span`
  width: 24px;
  height: 24px;
  font-size: 24px;
  color: ${colorYellow};
`;
const StatusText = styled.p`
  margin-right: 10px;
  padding: 0px 8px;
  color: white;
  font-size: 10px;
  border-radius: 11px;
`;
const NewStatus = styled(StatusText)`
  background-color: #007bff; /* Blue */
  font-size: 11px;
  border-radius: 10px;
`;

const ImprovedStatus = styled(StatusText)`
  background-color: #28a745; /* Green */
  border-radius: 10px;
  font-size: 11px;
`;

const BugStatus = styled(StatusText)`
  background-color: #dc3545; /* Red */
  border-radius: 10px;
  font-size: 11px;
`;
const BugFixStatus = styled(StatusText)`
  background-color: #f8a745; /* Red */
  border-radius: 10px;
  font-size: 11px;
`;

const EnhancementStatus = styled(StatusText)`
  background-color: #28a795;
  border-radius: 10px;
  font-size: 11px;
`;
